import { APP_COLOR, FONT_FAMILY } from "../../theme";

export const styles = {
  emptySpan: {
    color: "red",
    fontFamily: FONT_FAMILY,
    fontSize: 13,
    marginTop: 20,
  } as const,
  numberCharacterErrorSpan: {
    color: "red",
    fontFamily: FONT_FAMILY,
    fontSize: 13,
    marginTop: 20,
  } as const,
  usernameErrorSpan: {
    color: "red",
    fontFamily: FONT_FAMILY,
    fontSize: 13,
    marginTop: 20,
  } as const,
  inputFieldStyle: {
    "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: APP_COLOR,
    },
  } as const,
  inputErrorFieldStyle: {
    "& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
      borderColor: "red",
    },
  } as const,
};
